import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import sortBlockService from './sortBlockService';

// Get user from

const initialState = {
  getLinkList: [],
  linkListError: false,
  linkListSuccess: false,
  linkListLoading: false,
  linkListErrorMsg: '',
};

// creating____________bioLink____________________
export const sortBlocksLink = createAsyncThunk(
  'linkList/sortBlocksLink',

  async (linkListData, thunkAPI) => {
    try {
      return await sortBlockService.sortBlockLink(linkListData);
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const linkListErrorMsg =
        (error.response && error.response.data && error.response.data.linkListErrorMsg) ||
        error.linkListErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(linkListErrorMsg);
    }
  }
);
export const linkListSlice = createSlice({
  // handle the api response(promise coming from api) , either
  name: 'sortBlockList',
  initialState,
  reducers: {
    resetLinkList: (state) => {
      state.linkListLoading = false;
      state.linkListSuccess = false;
      state.linkListError = false;
      state.linkListErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sortBlocksLink.pending, (state) => {
        state.linkListLoading = true;
      })
      .addCase(sortBlocksLink.fulfilled, (state, action) => {
        state.linkListLoading = false;
        state.linkListSuccess = true;
        state.getLinkList = action.payload;
      })
      .addCase(sortBlocksLink.rejected, (state, action) => {
        state.linkListLoading = false;
        state.linkListError = true;
        state.linkListErrorMsg = action.payload; // error from catch will come here via action.payload and update linkListErrorMsg
      });
  },
});
export const { resetLinkList } = linkListSlice.actions;
export default linkListSlice.reducer;
